export default "__VITE_ASSET__aafcef85__"